<template>
  <a-row id="createStep" style="width: 100%">
    <integrationNipModal
      ref="integrationNipModal"
      @handlerNipClose="handlerNipClose"
    />
    <a-form-model
      id="salesform"
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item
            :label="$t('Spółka')"
            prop="company"
            style="margin-bottom: 5px"
          >
            <a-select
              v-model="form.company"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="handleCompanyChange($event)"
            >
              <a-select-option
                v-for="item in this.info.my_company"
                :key="item.ID"
                >{{ item.TITLE }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Data wystawienia')" prop="billingDate">
            <a-date-picker
              v-model="form.billingDate"
              type="date"
              :locale="locale"
              style="width: 100%"
              @change="handlebillingDate($event)"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccount">
            <a-col :span="12" style="width: 83%; margin-right: 5px">
              <a-dropdown :trigger="['click']">
                <a-input class="ant-dropdown-link" v-model="form.bankAccount" />
                <a-menu slot="overlay">
                  <a-menu-item
                    v-for="(item, index) in bankAccountList"
                    :key="index"
                    @click="
                      () => {
                        handleChangeSelectAccount(item);
                      }
                    "
                    >{{ item }}</a-menu-item
                  >
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-button
              type="primary"
              icon="plus"
              @click="
                () => {
                  addNewKonto();
                }
              "
              :size="size"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
            <a-date-picker
              v-model="form.saleDate"
              type="date"
              :format="YYYY - MM - DD"
              :locale="locale"
              @change="handleSaleDateChange"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
            <!--<a-select
              v-model="form.contractor"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              @dropdownVisibleChange="companyUpdate"
              :filter-option="filterOption"
              @change="handleContractorChange($event)"
              style="width: 83%; margin-right: 5px"
            >
              <a-select-option
                v-for="(comp, id) in COMPANY_LIST"
                :key="id"
              >{{
                comp.TITLE
              }}</a-select-option>
            </a-select>-->
            <a-input
              style="width: 83%; margin-right: 5px"
              v-model="companyTitle"
              @click="handleContractorChange($event)"
            />
            <a-button
              @click="$refs.integrationNipModal.showModal()"
              type="primary"
              icon="plus"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Data usługi')">
            <a-date-picker
              v-model="form.serviceDate"
              type="date"
              :locale="locale"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Opiekun')">
            <a-select
              show-search
              option-filter-prop="children"
              v-model="Opiekun"
              :filter-option="filterOption"
              @change="handleUserChange($event)"
              style="width: 100%"
            >
              <a-select-option
                v-for="item in this.responsible"
                :key="item.ID"
                >{{ item.NAME + " " + item.LAST_NAME }}</a-select-option
              >
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
            <a-date-picker
              v-model="form.dueDate"
              type="date"
              :locale="locale"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Projekt')">
            <a-select
              v-model="form.project"
              placeholder="please select"
              show-search
              allowClear
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option v-for="item in this.project" :key="item.ID">{{
                item.TITLE + " (" + item.ID + ")"
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
            <a-date-picker
              v-model="form.reminder"
              type="date"
              :locale="locale"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
            <a-select
              v-model="form.invoiceType"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              default-value="Faktura"
              @change="handlerInvoiceType"
            >
              <a-select-option value="Faktura">{{
                $t("Faktura Kosztowa")
              }}</a-select-option>
              <a-select-option value="Proforma">{{
                $t("Proforma")
              }}</a-select-option>
              <a-select-option value="VAT Marza">{{
                $t("Faktura do Proformy")
              }}</a-select-option>
              <a-select-option value="Korekta">{{
                $t("Korygująca")
              }}</a-select-option>
              <a-select-option value="Faktura zaliczkowa">{{
                $t("Faktura zaliczkowa")
              }}</a-select-option>
              <a-select-option value="Faktura koncowa">{{
                $t("Faktura koncowa")
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-item
            v-if="
              ['Prepayment', 'Correction'].includes(selectInvoiceCorrection)
            "
          >
            <template slot="label">
              <span v-if="selectInvoiceCorrection == 'Correction'">{{
                $t("Corrected document")
              }}</span>
              <span v-if="selectInvoiceCorrection == 'Prepayment'">{{
                $t("Prepayment document")
              }}</span>
            </template>
            <div style="display: flex">
              <a-select
                showSearch
                v-model="form.invoiceCorrection"
                optionFilterProp="children"
                @change="handlerInvoiceCorrection"
              >
                <a-select-option
                  v-for="itm in invoiceCorrectionVaribl"
                  :key="itm.ID"
                  >{{ itm.invoiceTitle }}</a-select-option
                >
              </a-select>
              <a-button
                v-if="this.sale_record != null && this.sale_record != undefined"
                @click="showDrawer"
                type="link"
                icon="eye"
              />
            </div>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Płatność')" prop="paymentType">
            <a-select
              v-model="form.paymentType"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              default-value="Przelew"
            >
              <a-select-option key="Gotówka">{{
                $t("Gotówka")
              }}</a-select-option>
              <a-select-option key="Przelew">{{
                $t("Przelew")
              }}</a-select-option>
              <a-select-option key="Karta">{{ $t("Karta") }}</a-select-option>
              <a-select-option key="Pobranie">{{
                $t("Pobranie")
              }}</a-select-option>
              <a-select-option key="Kompensata">{{
                $t("Kompensata")
              }}</a-select-option>
              <a-select-option key="Barter">{{ $t("Barter") }}</a-select-option>
              <a-select-option key="Płatność przez Pracownika">{{ $t("Płatność przez Pracownika") }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Opis')" prop="description">
            <a-input v-model="form.description" type="textarea" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-select
                  v-model="form.currency"
                  placeholder="please select"
                  @change="handleCurrencyChange($event)"
                >
                  <a-select-option
                    v-for="itemCurr in currencyValues"
                    :key="itemCurr"
                    >{{ itemCurr }}</a-select-option
                  >
                </a-select>
              </a-col>
              <a-col :span="12">
                <a-input v-model="form.course" disabled />
              </a-col>
            </a-row>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :label="$t('Język')">
            <a-select
              v-model="form.language"
              placeholder="please select"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option value="Polski">{{
                $t("Polskie")
              }}</a-select-option>
              <a-select-option value="Język angielski">{{
                $t("Język angielski")
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-table
          :columns="columns"
          :data-source="dataSource"
          :pagination="{ 'show-size-changer': true }"
          bordered
          tableLayout="auto"
          :scroll="{ x: true }"
          prop="table"
        >
          <template slot="name" slot-scope="text, record">
            <a-tree-select
              v-if="record.editable"
              show-search
              style="width: 100%"
              :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
              :tree-data="productTreeBySection"
              placeholder="Please select"
              treeNodeFilterProp="title"
              @select="
                (id, node) =>
                  handleChangeSelectProduct(node.dataRef, record.key, 'name')
              "
            >
            </a-tree-select>
            <template v-else>{{ text }}</template>
          </template>

          <template slot="units" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              style="margin: -5px 0; width: 100%"
              placeholder="Select a rate"
              :value="text"
              @change="(e) => handleChange(e, record.key, 'units')"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in MEASURE_LIST"
                :key="item.symbolLetterIntl"
                >{{ item.symbolLetterIntl }}</a-select-option
              >
            </a-select>

            <template v-else>{{ text }}</template>
          </template>

          <template slot="type_arrival" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              style="margin: -5px 0; width: 100%"
              placeholder="Select a type"
              :value="text"
              @change="(e) => handleChange(e, record.key, 'type_arrival')"
              show-search
              :default-value="typeFromMedia"
              option-filter-prop="children"
              :filter-option="filterOption"
            >
              <a-select-option
                v-for="item in user_setup.RodzajPrzychodu"
                :key="item"
                >{{ item }}</a-select-option
              >
            </a-select>

            <template v-else>{{ text }}</template>
          </template>

          <template slot="vat_rate" slot-scope="text, record">
            <a-select
              v-if="record.editable"
              style="margin: -5px 0; width: 100%"
              placeholder="Select a rate"
              @change="(e) => handleChange(e, record.key, 'vat_rate')"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              :default-value="0"
            >
              <a-select-option v-for="(item, index) in VAT_LIST" :key="index">{{
                item.NAME
              }}</a-select-option>
            </a-select>

            <template v-else>{{ text }}</template>
          </template>

          <template
            v-for="col in ['unit_price', 'quantity']"
            :slot="col"
            slot-scope="text, record"
          >
            <div :key="col">
              <a-input
                v-if="record.editable"
                style="margin: -5px 0"
                :value="text"
                @change="(e) => handleChange(e.target.value, record.key, col)"
              />
              <template v-else>{{ text }}</template>
            </div>
          </template>

          <template slot="operation" slot-scope="text, record">
            <a-row class="editable-row-operations" style="text-align: center">
              <span v-if="record.editable">
                <a-col :span="12">
                  <a
                    :disabled="
                      !record.name || !record.Netto || !record.quantity
                    "
                    @click="() => saveTable(record.key)"
                  >
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="save"
                    />
                  </a>
                </a-col>
                <a-col :span="12">
                  <a @click="() => cancelTable(record.key)">
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="stop"
                      theme="twoTone"
                    />
                  </a>
                </a-col>
              </span>
              <span v-else>
                <a-col :span="12">
                  <a
                    :disabled="editingKey !== ''"
                    @click="() => editTable(record.key)"
                  >
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="edit"
                    />
                  </a>
                </a-col>
                <a-col :span="12">
                  <a
                    :disabled="editingKey !== ''"
                    @click="() => deleteTable(record.key)"
                  >
                    <a-icon
                      style="
                         {
                          fontsize: '18px';
                        }
                      "
                      type="delete"
                    />
                  </a>
                </a-col>
              </span>
            </a-row>
          </template>
        </a-table>
        <a-button type="primary" class="editable-add-btn" @click="handleAdd">{{
          $t("Dodaj")
        }}</a-button>
      </a-row>
      <!--  <a-row :gutter="16" style="margin-top: 10px">
        <a-col :span="9"></a-col>
        <a-col :span="5">
          <a-form-model-item :label="$t('Netto')" prop="netto">
            <a-input
              v-model="this.nettoVal"
              disabled
              style="background-color: #e4edf9f2"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item :label="$t('Vat')" prop="vat">
            <a-input
              v-model="this.vatVal"
              disabled
              style="background-color: #e4edf9f2"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item :label="$t('Brutto')" prop="brutto">
            <a-input
              v-model="this.bruttoVal"
              disabled
              style="background-color: #e4edf9f2"
            />
          </a-form-model-item>
        </a-col>
      </a-row>-->
      <a-row :gutter="16" type="flex" justify="center" style="margin-top: 10px">
        <a-statistic
          :title="$t('Netto')"
          :value="this.nettoVal"
          style="margin-right: 25px"
          :precision="2"
        />
        <a-divider type="vertical" style="height: 5em" />
        <a-statistic
          :title="$t('Vat')"
          :value="this.vatVal"
          style="margin-right: 25px; margin-left: 25px"
          :precision="2"
        />
        <a-divider type="vertical" style="height: 5em" />
        <a-statistic
          :title="$t('Brutto')"
          :value="this.bruttoVal"
          style="margin-left: 25px"
          :precision="2"
        />
      </a-row>
    </a-form-model>
    <a-drawer
      :title="correctDATA.invoiceTitle"
      placement="right"
      :visible="visible"
      :width="900"
      :after-visible-change="afterVisibleChange"
      @close="onCloseDrawer"
    >
      <a-form
        id="my_form_styl"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="width: 100%"
      >
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Spółka')" prop="company">
              <div>{{ this.myCompanyCorrection }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :label="$t('Data wystawienia')"
              prop="billingDate"
            >
              <div>{{ correctDATA.billingDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Konto bankowe')" prop="bankAccaunt">
              <div>{{ correctDATA.bankAccount }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data sprzedaży')" prop="saleDate">
              <div>{{ correctDATA.saleDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Kontrahent')" prop="contractor">
              <div>{{ this.contractorCorrection }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Data usługi')">
              <div>{{ correctDATA.serviceDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Opiekun')">
              <div>
                {{
                  this.userCorrection.NAME + " " + this.userCorrection.LAST_NAME
                }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Termin płatności')" prop="dueDate">
              <div>{{ correctDATA.dueDate }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Projekt')">
              <div>{{ this.DEALcorrection }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Przypomnienie')" prop="reminder">
              <div>{{ correctDATA.reminder }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Rodzaj')" prop="invoiceType">
              <div>{{ correctDATA.invoiceType }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              v-if="
                this.correctDATA.invoiceCorrection != '' ||
                this.correctDATA.correctionBack != ''
              "
              :label="$t('Korekta')"
            >
              <div>{{ invTitleifSalerec }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Payment')" prop="paymentType">
              <div>{{ correctDATA.paymentType }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Opis')">
              <div>{{ correctDATA.description }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item :label="$t('Waluta, kurs')" prop="currency">
              <a-row :gutter="16">
                <a-col :span="12">
                  <div>{{ correctDATA.currency }}</div>
                </a-col>
                <a-col :span="12">
                  <div>{{ this.currencyAmoutCorrection }}</div>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="$t('Język')">
              <div>{{ correctDATA.language }}</div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-table
            :columns="columns"
            tableLayout="auto"
            :scroll="{ x: true }"
            :data-source="dataSourceCorrection"
            :pagination="{ hideOnSinglePage: true }"
            bordered
          ></a-table>
        </a-row>
      </a-form>
    </a-drawer>
  </a-row>
</template>
<script>
import moment from "moment";
import {
  requestStep,
  getInvoiceSalesCorrection,
  getCurrency,
} from "@/requestFunc";
import integrationNipModal from "@/components/integrationNipModal";
import locale from "ant-design-vue/es/date-picker/locale/pl_PL";
import { mapGetters } from "vuex";

export default {
  props: [
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "VAT_LIST",
    "info",
    "user_setup",
    "sale_record",
    "DEAL",
    "checkMedia",
    "dataSales",
  ],
  components: { integrationNipModal },
  computed: { ...mapGetters(["companyFieldForNIP"]) },
  data() {
    return {
      columns: [
        {
          title: this.$t("Nazwa produktu"),
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: this.$t("Jednostka"),
          dataIndex: "units",
          scopedSlots: { customRender: "units" },
        },
        {
          title: this.$t("Rodzaj przychodu"),
          dataIndex: "type_arrival",
          scopedSlots: { customRender: "type_arrival" },
        },
        {
          title: this.$t("Stawka VAT"),
          dataIndex: "vat_rate",
          scopedSlots: { customRender: "vat_rate" },
        },
        {
          title: this.$t("Ilość"),
          dataIndex: "quantity",
          scopedSlots: { customRender: "quantity" },
        },
        {
          title: this.$t("Cena"),
          dataIndex: "unit_price",
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: this.$t("Netto"),
          dataIndex: "Netto",
        },
        {
          title: this.$t("Vat"),
          dataIndex: "Vat",
        },
        {
          title: this.$t("Brutto"),
          dataIndex: "Brutto",
        },
        {
          title: this.$t("Operacje"),
          dataIndex: "operation",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "operation" },
        },
      ],
      locale,
      typeFromMedia: "",
      currencyAmout: "",
      currencyAmoutCorrection: "",
      myCompanyCorrection: "",
      contractorCorrection: "",
      dataSourceCorrection: [],
      userCorrection: [],
      DEALcorrection: "",
      invTitleifSalerec: "",
      selectInvoiceCorrection: "",
      invoiceCorrectionVaribl: [],
      domain: null,
      dataSource: [],
      checkNull: 0,
      cacheData: [],
      currencyDate: "",
      Opiekun: "",
      payDay: "",
      visible: false,
      editingKey: "",
      bankAccountList: [],
      productTreeBySection: [],
      PRODUCT_LIST: [],
      SECTION_LIST: [],
      DEAL_LIST: [],
      MEASURE_LIST: [],
      currencyValues: [],
      responsible: [],
      project: [],
      nettoVal: 0,
      vatVal: 0,
      companyTitle: "",
      bruttoVal: 0,
      correctDATA: [],
      update: {},
      statuGoSteps: {},
      form: {
        media: "",
        ID: "",
        company: "",
        bankAccount: "",
        contractor: "",
        responsible: "",
        project: "",
        invoiceType: "",
        paymentType: "",
        course: "",
        currency: "",
        language: "",
        description: "",
        positions: [],
        billingDate: "",
        dueDate: "",
        serviceDate: "",
        saleDate: "",
        reminder: "",
        invoiceCorrection: "",
        correctionBack: "",
      },
      rules: {
        currency: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        paymentType: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        invoiceType: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        contractor: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        bankAccaunt: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        serviceDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        saleDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        dueDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        billingDate: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
        table: [
          {
            required: true,
            message: "Pole nie może być puste",
            trigger: "change",
          },
        ],
      },
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    moment,
    afterVisibleChange() {},
    showDrawer() {
      this.visible = true;
    },
    onCloseDrawer() {
      this.visible = false;
    },
    companyUpdate(open) {
      if (open) {
        BX24.callMethod(
          "crm.company.list",
          {
            filter: {
              ">ID": this.info.company[this.info.company.length - 1].ID,
            },
            select: ["ID", "TITLE", this.companyFieldForNIP, "ASSIGNED_BY_ID"],
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              let res = result.data();
              this.info.company = this.info.company.concat(res);
              if (result.more()) result.next();
            }
          }
        );
      }
    },
    handlerNipClose(companyID) {
      if (companyID) {
        if (this.COMPANY_LIST[companyID]) {
          let id = companyID.toString();
          this.form.contractor = id;
          this.handleContractorChange(id);
        } else {
          BX24.callMethod("crm.company.get", { id: companyID }, (result) => {
            if (result.error()) console.error(result.error());
            else {
              let companyInfo = result.data();
              this.COMPANY_LIST = Object.assign({}, this.COMPANY_LIST, {
                [companyID]: companyInfo,
              });
              this.form.contractor = companyInfo.ID;
              this.handleContractorChange(companyInfo.ID);
            }
          });
        }
      }
    },
    handleCompanyChange(event) {
      this.bankAccountList = this.info.my_company.filter((el) => {
        if (el.ID == event) return el;
      })[0][this.user_setup.BankAccount];
      // console.log(this.bankAccountList, "this.bankAccountList");
      this.form.bankAccount = this.bankAccountList
        ? this.bankAccountList.length > 0
          ? this.bankAccountList[0]
          : []
        : [];
    },
    handleChangeSelectAccount(item) {
      this.form.bankAccount = item;
    },
    handleUserChange(event) {
      this.form.responsible = event;
    },
    handleContractorChange() {
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: false,
        },
        (info) => {
          //company = info.company[0].id.split("_")[1];
          this.form.contractor = info.company[0].id.split("_")[1];

          this.companyTitle = info.company[0].title;
          this.form.project = "";

          BX24.callMethod(
            "crm.deal.list",
            { filter: { COMPANY_ID: this.form.contractor } },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                this.project = result.data();
              }
            }
          );

          /* this.project = this.DEAL_LIST.filter(
              (el) => el.COMPANY_ID == event || el.ID == this.dataSales.id
            );*/
          /* this.companyContractor =
              this.info.company.find((el) => el.ID == event) || {};*/

          /* this.responsible = this.info.data_user.filter((el) => {
              if (
                el.ID == this.dataSales.opiekunCS ||
                el.ID == this.companyContractor.ASSIGNED_BY_ID ||
                this.user_setup.responsibleSpredz.includes(el.ID) ||
                this.user_setup.responsibleAll.includes(el.ID)
              )
                return el;
            });*/

          /* let search = this.checkMedia
              ? this.dataSales.opiekunCSect = this.dataSales.id;
            var findOpiekun = this.info.data_user.find((el) => el.ID == search);
            if (findOpiekun) {
              : this.companyContractor.ASSIGNED_BY_ID;
            if (this.checkMedia) this.form.projeect = this.dataSales.id;
            var findOpiekun = this.info.data_user.findect = this.dataSales.id;
            var findOpiekun = this.info.data_user.find((el) => el.ID == search);
            if (findOpiekun) {((el) => el.ID == search);
            if (findOpiekun) {
              this.Opiekun = findOpiekun.ID;
              this.form.responsible = findOpiekun.ID;
            } else {
              this.Opiekun = "";
              this.form.responsible = "";
            }*/

          BX24.callMethod(
            "crm.company.get",
            { id: this.form.contractor },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                var companyInfo = result.data();
                //this.payDay = this.info.company.find((el) => event == el.ID) || {};
                if (companyInfo[this.user_setup.termin]) {
                  this.form.dueDate = moment().add(
                    companyInfo[this.user_setup.termin],
                    "days"
                  );
                }

                let userArray = [];
                let usersArray = userArray.concat(
                  this.dataSales.opiekunCS,
                  companyInfo.ASSIGNED_BY_ID,
                  this.user_setup.responsibleSpredz,
                  this.user_setup.responsibleAll
                );

                BX24.callMethod("user.get", { id: usersArray }, (result) => {
                  if (result.error()) console.error(result.error());
                  else {
                    this.responsible = result.data();
                  }
                });
              }
            }
          );

          /*this.payDay = this.info.company.find((el) => event == el.ID) || {};
            if (this.payDay[this.user_setup.termin]) {
              this.form.dueDate = moment().add(
                this.payDay[this.user_setup.termin],
                "days"
              );
            }*/
        }
      );
    },
    handlerInvoiceType(e) {
      this.selectInvoiceCorrection = "";
      var kontragent = this.form.contractor || this.sale_record.contractor;
      var my_company = this.form.company || this.sale_record.company;
      if (
        my_company &&
        kontragent &&
        ["Korekta", "Faktura koncowa", "VAT Marza", "Proforma"].includes(e)
      ) {
        if (Object.keys(this.sale_record)) {
          this.form.ID = this.sale_record.ID;
        } else {
          this.form.ID = 0;
        }
        let types = {
          Korekta: "Correction",
          "Faktura koncowa": "Prepayment",
          "VAT Marza": "",
          Proforma: "",
        };
        getInvoiceSalesCorrection({
          type: types[e],
          current_id: this.form.ID,
          my_company,
          kontragent,
        }).always((res) => {
          let data = JSON.parse(res);

          this.invoiceCorrectionVaribl = data;
          this.selectInvoiceCorrection = types[e];
        });
      }
    },
    handlerInvoiceCorrection() {},
    preview() {},
    handleCurrencyChange(event) {
      var curr = this.info.currency.find((x) => x.CURRENCY == event);
      if (!this.currencyDate || curr?.CURRENCY == "PLN") {
        this.form.course = curr.AMOUNT;
      } else {
        this.form.currency = curr?.CURRENCY;
        this.handleSaleDateChange();
      }
    },
    handleSaleDateChange(e) {
      let code = this.form.currency;
      let date = e ? e : moment(this.form.saleDate);
      if (date) {
        date = moment(date).subtract(1, "days");
        this.currencyDate =
          date.isoWeekday() > 5
            ? date.subtract(date.isoWeekday() - 5, "days").format("YYYY-MM-DD")
            : date.format("YYYY-MM-DD");

        if (code != "PLN") {
          getCurrency({ code, date: this.currencyDate }).done((data) => {
            let res = JSON.parse(data);
            if (res?.currency) {
              this.form.course = res.rates[0]["mid"];
              this.$message.success(this.$t("Currency updated"));
            }
          });
        }
      }
    },
    onSubmit(updateStatus) {
      this.$refs.form.validate((valid) => {
        this.changeSpinning();
        if (valid) {
          let format_moment = (date) =>
            date ? moment(date).format("YYYY-MM-DD") : "";

          this.form.billingDate = format_moment(this.form.billingDate);
          this.form.dueDate = format_moment(this.form.dueDate);
          this.form.serviceDate = format_moment(this.form.serviceDate);
          this.form.saleDate = format_moment(this.form.saleDate);
          this.form.reminder = format_moment(this.form.reminder);
          if (Object.keys(this.sale_record)) {
            this.form.ID = this.sale_record.ID;
            this.form.correctionBack = this.sale_record.ID;
          } else {
            this.form.ID = 0;
          }
          var allData = this.saveValues();
          this.form.positions = this.dataSource;
          this.form["run"] = "createSaleAndSaveStageOne";
          this.form["updateStatus"] = updateStatus;
          requestStep(allData, "./php/request.php")
            .done((data) => {
              let res = JSON.parse(data);
              if (res.status == "error") {
                this.$message.error("Błąd podczas tworzenia konta");
              } else {
                if (this.checkMedia != true) {
                  let prev = this.sale_record.status;
                  this.sale_record = Object.assign(this.sale_record, res.data);
                  if (updateStatus == true) {
                    this.onClose({
                      prev,
                      next: status,
                      element: this.sale_record,
                    });
                    this.goSteps(this.sale_record);
                  } else {
                    this.$emit("generatrDoc", res.docID);
                  }
                } else {
                  this.onClose();
                  this.onBackMedia();
                }
                this.$message.success("Tworzenie faktury zakończone!");
              }
            })
            .always(() => {
              this.changeSpinning();
            });
        } else {
          this.changeSpinning();
          return false;
        }
      });
    },
    onBackMedia() {
      let data = true;
      this.$emit("onBackMedia", data);
    },
    saveValues() {
      let media = this.checkMedia ? this.dataSales.id : "";
      let dataFL = {
        run: "createSaleAndSaveStageOne",
        positions: this.dataSource,
        media: media,
      };
      let datanew = {};
      if (Object.keys(this.sale_record)) {
        dataFL["ID"] = this.sale_record.ID;
      } else {
        return false;
      }
      /* let update = {
        PaymentDateReal: values.PaymentDateReal
          ? moment(values.PaymentDateReal).format("YYYY-MM-DD")
          : ""
      };*/
      Object.assign(datanew, this.form);

      for (let key in datanew) {
        if (
          key in this.sale_record &&
          JSON.stringify(datanew[key]) != JSON.stringify(this.sale_record[key])
        ) {
          datanew[key] = {
            old: this.sale_record[key],
            new: datanew[key],
          };
        } else {
          datanew[key] = {
            old: "",
            new: datanew[key],
          };
        }
      }

      delete datanew.ID;
      delete datanew.positions;
      delete datanew.media;
      Object.assign(dataFL, datanew);
      this.$emit("checkPositionFunc", this.dataSource);
      return dataFL;
    },
    handleAdd() {
      let unitPrice = this.checkMedia ? this.dataSales.plan : 0;
      let typeArrival = this.checkMedia ? this.typeFromMedia : "";
      let checkName = this.checkMedia ? this.dataSales.project : "";
      for (let i in this.dataSource) {
        if (this.dataSource[i]["editable"]) {
          if (this.dataSource[i].namefield && this.dataSource[i].koszty) {
            this.saveTable(this.dataSource[i].key);
            break;
          } else {
            return;
          }
        }
      }
      const newData = {
        key: this.dataSource?.length || 0,
        name: checkName,
        units: "Szt",
        vat_rate: "23",
        quantity: "1",
        unit_price: unitPrice,
        Brutto: 0,
        Vat: 0,
        Netto: 0,
        type_arrival: typeArrival,
        editable: true,
      };
      this.dataSource = [...this.dataSource, newData];
      this.editingKey = newData.key;
      this.cacheData = this.dataSource.map((item) => ({
        ...item,
      }));
      this.$emit("checkPositionFunc", this.dataSource);

      if (this.checkMedia) {
        this.handleChange("1", this.editingKey, "quantity");
        this.saveTable(this.editingKey);
      }
    },
    addNewKonto() {
      var params = {};
      if (Array.isArray(this.bankAccountList)) {
        if (!this.bankAccountList.includes(this.form.bankAccount)) {
          this.bankAccountList.push(this.form.bankAccount);
          params[this.user_setup.BankAccount] = this.bankAccountList;

          BX24.callMethod(
            "crm.company.update",
            {
              id: this.form.company,
              fields: params,
            },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                this.$message.success("Dodano nowe konto bankowe!");
                console.info(result.data());
              }
            }
          );
        } else {
          this.$message.warning("Takie konto bankowe już istnieje!");
        }
      } else {
        this.bankAccountList = [this.form.bankAccount];
        params[this.user_setup.BankAccount] = this.bankAccountList;

        BX24.callMethod(
          "crm.company.update",
          {
            id: this.form.company,
            fields: params,
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.$message.success("Dodano nowe konto bankowe!");
              console.info(result.data());
            }
          }
        );
      }
    },
    handleChange(value, key, column) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        if (column == "vat_rate") {
          target[column] = this.VAT_LIST[value]["RATE"];
        } else {
          target[column] = value;
        }

        this.dataSource = newData;

        if (
          column == "vat_rate" ||
          column == "quantity" ||
          column == "unit_price" ||
          column == "type_arrival" ||
          column == "units" ||
          column == "name"
        ) {
          target.Netto = !isNaN(target.quantity * target.unit_price)
            ? target.quantity * target.unit_price
            : 0;
          target.Vat = !isNaN((target.Netto * target.vat_rate) / 100)
            ? (target.Netto * target.vat_rate) / 100
            : 0;
          target.Brutto = !isNaN(target.Vat + target.Netto)
            ? target.Vat + target.Netto
            : 0;
          target.Netto = target.Netto.toFixed(2);
          target.Vat = target.Vat.toFixed(2);
          target.Brutto = target.Brutto.toFixed(2);
        }
      }
      this.$emit("checkPositionFunc", this.dataSource);
    },
    handleChangeSelectProduct(product, key) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target["productID"] = product.value;
        target["name"] = product.title;
        //target["units"] = product["MEASURE"];
        // TODO product vat
        // target["vat_rate"] = this.VAT_LIST.find(x => x.ID == product["VAT_ID"]);
        target["unit_price"] = product.price;

        this.dataSource = newData;
        this.handleChange(product.title, key, "name");
      }
    },
    deleteTable(key) {
      this.nettoVal = 0;
      this.vatVal = 0;
      this.bruttoVal = 0;
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter((item) => item.key !== key);
      for (let item of this.dataSource) {
        this.nettoVal += item.Netto * 1;
        this.vatVal += item.Vat * 1;
        this.bruttoVal += item.Brutto * 1;
      }
      this.nettoVal = this.nettoVal.toFixed(2);
      this.vatVal = this.vatVal.toFixed(2);
      this.bruttoVal = this.bruttoVal.toFixed(2);
      this.$emit("checkPositionFunc", this.dataSource);
    },
    editTable(key) {
      this.nettoVal = 0;
      this.vatVal = 0;
      this.bruttoVal = 0;
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = key;
      if (target) {
        for (let item of newData) {
          this.nettoVal += item.Netto * 1;
          this.vatVal += item.Vat * 1;
          this.bruttoVal += item.Brutto * 1;
        }
        this.nettoVal = this.nettoVal.toFixed(2);
        this.vatVal = this.vatVal.toFixed(2);
        this.bruttoVal = this.bruttoVal.toFixed(2);
        target.editable = true;
        this.dataSource = newData;
      }
      this.$emit("checkPositionFunc", this.dataSource);
    },
    saveTable(key) {
      this.nettoVal = 0;
      this.vatVal = 0;
      this.bruttoVal = 0;
      // TODO высчитывать ват нетто брутоо
      const newData = [...this.dataSource];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.dataSource = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
        for (let item of newData) {
          this.nettoVal += item.Netto * 1;
          this.vatVal += item.Vat * 1;
          this.bruttoVal += item.Brutto * 1;
        }
        this.nettoVal = this.nettoVal.toFixed(2);
        this.vatVal = this.vatVal.toFixed(2);
        this.bruttoVal = this.bruttoVal.toFixed(2);
      }
      this.editingKey = "";
      this.$emit("checkPositionFunc", this.dataSource);
    },
    handlebillingDate(event) {
      if (this.payDay != null && this.payDay != "") {
        let format_moment = (date) =>
          date ? moment(date).format("YYYY-MM-DD") : "";
        let d = format_moment(event);
        let finD = new Date(d);

        // var editTime = finD.setDate(finD.getDate() + Number(this.payDay));
        var curr_date = finD.getDate();
        var curr_month = finD.getMonth();
        var curr_year = finD.getFullYear();

        this.form.dueDate = curr_year + "-" + curr_month + "-" + curr_date;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    cancelTable(key) {
      const newData = [...this.dataSource];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCach = this.cacheData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target && targetCach.name && targetCach.Netto) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.dataSource = newData;
      } else {
        this.deleteTable(key);
      }
      this.$emit("checkPositionFunc", this.dataSource);
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    onClose(element) {
      this.$emit("onClose", element);
    },
    goSteps(record) {
      //this.statuGoSteps = { status: "Oczekujący", ID: ID };
      this.$emit("goSteps", record);
    },
  },
  mounted() {
    //this.handleCompanyChange(this.form.company);
    this.form.invoiceType = "Faktura";
    this.form.paymentType = "Przelew";
    this.form.language = "Polski";
    let dat = new Date();
    var curr_date_mou = dat.getDate();
    var curr_month_mou = dat.getMonth() + 1;
    var curr_year_mou = dat.getFullYear();
    var curr_date_mou_for = dat.getDate() - 1;
    var curr_month_mou_for = dat.getMonth() + 1;
    var curr_year_mou_for = dat.getFullYear();
    let forCurrency =
      curr_year_mou_for + "-" + curr_month_mou_for + "-" + curr_date_mou_for;
    this.form.billingDate =
      curr_year_mou + "-" + curr_month_mou + "-" + curr_date_mou;
    this.form.saleDate =
      curr_year_mou + "-" + curr_month_mou + "-" + curr_date_mou;
    this.currencyDate = forCurrency;

    if (Object.keys(this.sale_record).length != 0) {
      this.nettoVal = this.sale_record.netto;
      this.vatVal = this.sale_record.vat;
      this.bruttoVal = this.sale_record.totalAmout;
      this.invTitleifSalerec = this.sale_record.invoiceTitle;
      let kk = this.sale_record.allCompany.find((el) => {
        if (this.sale_record.contractor == el.ID) return el;
      });
      this.payDay = kk ? kk[this.user_setup.termin] : "";
      // this.handleContractorChange(this.sale_record.contractor);
      this.dataSource = this.sale_record.positions || [];
      this.cacheData = this.dataSource;
      this.handlerInvoiceType(this.sale_record.invoiceType);
      this.handleCurrencyChange(this.sale_record.currency);

      BX24.callMethod(
        "entity.item.get",
        {
          ENTITY: "invoices",
          FILTER: { ID: this.sale_record.invoiceCorrection },
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            let kk = result.data()[0];
            this.invoiceCorrectionVaribl = this.invoiceCorrectionVaribl.concat(
              kk?.PROPERTY_VALUES
            );
          }
        }
      );
      this.form.invoiceCorrection = this.sale_record.invoiceCorrection;

      BX24.callMethod(
        "crm.deal.list",
        { filter: { COMPANY_ID: this.sale_record.contractor } },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            this.project = result.data();
          }
        }
      );

      this.companyContractor =
        this.sale_record.allCompany.find(
          (el) => el.ID == this.sale_record.contractor
        ) || {};

      this.companyTitle = this.companyContractor.TITLE;
      this.form.contractor = this.companyContractor.ID;

      let userArray = [];
      let usersArray = userArray.concat(
        this.companyContractor.ASSIGNED_BY_ID,
        this.user_setup.responsibleSpredz,
        this.user_setup.responsibleAll
      );

      BX24.callMethod("user.get", { id: usersArray }, (result) => {
        if (result.error()) console.error(result.error());
        else {
          this.responsible = result.data();
        }
      });
      let ll = this.sale_record.userInfo.find((el) => {
        if (el.ID == this.sale_record.responsible) return el;
      });
      this.Opiekun = ll?.ID;

      this.form.responsible = this.Opiekun;

      /* this.project = this.DEAL.filter((el) => {
        if (el.COMPANY_ID == this.sale_record.contractor) return el;
      });

      this.companyContractor =
        this.info.company.find((el) => el.ID == this.sale_record.contractor) ||
        {};

      this.responsible = this.info.data_user.filter((el) => {
        if (
          el.ID == this.companyContractor.ASSIGNED_BY_ID ||
          this.user_setup.responsibleSpredz.includes(el.ID) ||
          this.user_setup.responsibleAll.includes(el.ID)
        )
          return el;
      });
      let al = this.info.data_user.find((el) => {
        if (el.ID == this.sale_record.responsible) return el;
      });
      this.Opiekun = al?.ID;
      this.form.responsible = this.Opiekun;*/
      let arrayFields = [
        "company",
        "bankAccount",
        "contractor",
        "invoiceType",
        "paymentType",
        "currency",
        "project",
        "language",
        "description",
        "billingDate",
        "dueDate",
        "serviceDate",
        "saleDate",
        "reminder",
      ];
      for (let item of arrayFields) {
        if (this.sale_record[item]) this.form[item] = this.sale_record[item];
      }

      if (this.sale_record.invoiceCorrection) {
        BX24.callMethod(
          "entity.item.get",
          {
            ENTITY: "invoices",
            FILTER: { ID: this.sale_record.invoiceCorrection },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
                "invoiceTitle"
              ];
              this.correctDATA = result.data()[0]["PROPERTY_VALUES"];
              this.dataSourceCorrection = JSON.parse(
                this.correctDATA.positions
              );
              this.currencyAmoutCorrection = this.info.currency.filter((el) => {
                if (this.correctDATA.currency == el.CURRENCY) return el;
              })[0].AMOUNT;

              this.myCompanyCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.company == el.ID) return el;
              })[0].TITLE;

              this.contractorCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.contractor == el.ID) return el;
              })[0].TITLE;

              this.userCorrection = this.info.data_user.filter((el) => {
                if (this.correctDATA.responsible == el.ID) return el;
              })[0];

              BX24.callMethod(
                "crm.deal.get",
                { id: this.correctDATA.project },
                (result) => {
                  if (result.error()) console.error(result.error());
                  else {
                    this.DEALcorrection = result.data()["TITLE"];
                  }
                }
              );
            }
          }
        );
      } else if (this.sale_record.correctionBack) {
        BX24.callMethod(
          "entity.item.get",
          {
            ENTITY: "invoices",
            FILTER: { ID: this.sale_record.correctionBack },
          },
          (result) => {
            if (result.error()) console.error(result.error());
            else {
              this.titleCorrectionInv = result.data()[0]["PROPERTY_VALUES"][
                "invoiceTitle"
              ];
              this.correctDATA = result.data()[0]["PROPERTY_VALUES"];
              this.dataSourceCorrection = JSON.parse(
                this.correctDATA.positions
              );
              this.currencyAmoutCorrection = this.info.currency.filter((el) => {
                if (this.correctDATA.currency == el.CURRENCY) return el;
              })[0].AMOUNT;

              this.myCompanyCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.company == el.ID) return el;
              })[0].TITLE;

              this.contractorCorrection = this.info.company.filter((el) => {
                if (this.correctDATA.contractor == el.ID) return el;
              })[0].TITLE;

              this.userCorrection = this.info.data_user.filter((el) => {
                if (this.correctDATA.responsible == el.ID) return el;
              })[0];

              BX24.callMethod(
                "crm.deal.get",
                { id: this.correctDATA.project },
                (result) => {
                  if (result.error()) console.error(result.error());
                  else {
                    this.DEALcorrection = result.data()["TITLE"];
                  }
                }
              );
            }
          }
        );
      }
    }

    let auth = BX24.getAuth();
    this.domain = auth.domain;

    this.myCompany = this.info.my_company.map((el) => {
      return el;
    });

    this.currencyValues = this.info.currency.map((el) => {
      return el.CURRENCY;
    });

    this.form.currency = "PLN";
    this.handleCurrencyChange(this.form.currency);
    BX24.callMethod(
      "crm.deal.list",
      { select: ["ID", "TITLE", "COMPANY_ID"] },
      (result) => {
        if (result.error()) console.error(result.error());
        else {
          this.DEAL_LIST = this.DEAL_LIST.concat(result.data());
          if (result.more()) {
            result.next();
          } else {
            if (this.checkMedia) {
              // this.form.project = this.dataSales.id;
              this.form.contractor = this.dataSales.kontrahent;
              this.handleContractorChange(this.dataSales.kontrahent);
            }
          }
        }
      }
    );

    BX24.callMethod("catalog.measure.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        this.MEASURE_LIST = this.MEASURE_LIST.concat(result.data().measures);
      }
    });

    // BX24.callMethod(
    //   "crm.deal.userfield.get",
    //   {
    //     id: 206,
    //   },
    //   (result) => {
    //     if (result.error()) console.error(result.error());
    //     else {

    //       let resultList = result.data().LIST;
    //       this.typeFromMedia = resultList.find((el) => {
    //         return el.ID == this.dataSales.typPrzychodu;
    //       }).VALUE;
    //       if (this.checkMedia) this.handleAdd();
    //     }
    //   }
    // );

    BX24.callMethod(
      "crm.productsection.list",
      {
        //filter: {  },
        select: ["ID", "NAME"],
      },
      (result) => {
        if (result.error()) console.error(result.error());
        else {
          let sections = result.data();
          this.SECTION_LIST = this.SECTION_LIST.concat(sections);
          for (let section of sections) {
            this.productTreeBySection.push({
              title: section.NAME,
              value: section.ID,
              key: `section${section.ID}`,
              children: [],
            });
          }
          if (result.more()) result.next();
        }
      }
    );
    BX24.callMethod("crm.product.list", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        let products = result.data();
        this.PRODUCT_LIST = this.PRODUCT_LIST.concat(products);
        for (let i in this.SECTION_LIST) {
          this.productTreeBySection[i].children.push(
            ...products
              .filter((x) => x.SECTION_ID == this.SECTION_LIST[i].ID)
              .map((x) => {
                return {
                  title: x.NAME,
                  value: x.ID,
                  key: `product${x.ID}`,
                  price: x.PRICE,
                };
              })
          );
        }
        for (var itemProd of products) {
          if (!itemProd.SECTION_ID)
            this.productTreeBySection.push({
              title: itemProd.NAME,
              value: itemProd.ID,
              key: `product${itemProd.ID}`,
              price: itemProd.PRICE,
            });
        }
      }
    });
    this.$emit("checkPositionFunc", this.dataSource);
    BX24.fitWindow();
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.editable-add-btn {
  margin-top: 8px;
}
#salesform .ant-form-item {
  margin-bottom: 0 !important;
}
#salesform .ant-form-item-control,
#salesform .ant-form-item-control-wrapper,
#salesform .ant-form-item-label {
  padding: 0;
}
</style>